import { includes, isArray, trim, uniq } from 'lodash';
import helper from '../../bss-package-helper/js/helper';
var instance;
/**
 * @class Logger
 * @desc provides logger functionality
 */
var Logger = /** @class */ (function () {
    function Logger(debugMode) {
        this.debugMode = null;
        if (instance) {
            return instance;
        }
        this.debugMode = this._validateLoggerDebugMode(debugMode);
        if (window.console && this.debugMode) {
            this._checkDebugModeInterfaces();
        }
        instance = this;
        return instance;
    }
    /**
     * @desc validate logger debug mode
     */
    Logger.prototype._validateLoggerDebugMode = function (debugMode) {
        if (debugMode && isArray(debugMode)) {
            return validateDebugMode(debugMode.join(','));
        }
        return null;
    };
    /**
     * @desc check logger interfaces
     */
    Logger.prototype._checkDebugModeInterfaces = function () {
        var _this = this;
        if (this.debugMode && isArray(this.debugMode)) {
            // if 'all' is set among modes array do not check the rest - use 'all'
            if (includes(this.debugMode, 'all')) {
                this._setDebugModeInterface('all');
                // otherwise loop modes and set interfaces
            }
            else {
                this.debugMode.forEach(function (mode) {
                    _this._setDebugModeInterface(mode);
                });
            }
        }
    };
    /**
     * @desc defines logger interface methods
     */
    Logger.prototype._setDebugModeInterface = function (debugMode) {
        switch (debugMode) {
            case 'error':
                this.error = this._privateLog.bind(this, 'error');
                break;
            case 'warn':
                this.warn = this._privateLog.bind(this, 'warn');
                break;
            case 'info':
                this.info = this._privateLog.bind(this, 'info');
                break;
            case 'all':
                this.error = this._privateLog.bind(this, 'error');
                this.warn = this._privateLog.bind(this, 'warn');
                this.info = this._privateLog.bind(this, 'info');
                break;
        }
    };
    /**
     * @desc private method for logger functionality
     */
    Logger.prototype._privateLog = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var type = args[0];
        var message = args[1];
        // remove mode type
        args.shift();
        helper.validateMethodParams(args, { message: { isa: 'string' } });
        var style = this._getDebugStyle(type);
        var consoleHandler = this._getConsoleHandler(type);
        message = this._updateMessageWithPrefix(message, type);
        message = this._updateMessageWithStyleDirective(message, type);
        if (args.length === 1) {
            consoleHandler(message, style);
        }
        else if (args.length === 2) {
            consoleHandler(message, style, args[1]);
        }
        else {
            var params_1 = {};
            // remove message, leave only params
            args.shift();
            args.forEach(function (el, i) {
                params_1['param' + (i)] = el;
            });
            consoleHandler(message, style, params_1);
        }
    };
    /**
     * @desc update message with style directive
     */
    Logger.prototype._updateMessageWithStyleDirective = function (message, type) {
        if (includes(['warn', 'error'], type)) {
            return "%c".concat(message);
        }
        return message;
    };
    /**
     * @desc update message with prefix depending on type: INFO, WARN, ERROR
     */
    Logger.prototype._updateMessageWithPrefix = function (message, type) {
        var prefix = '';
        switch (type) {
            case 'error':
                prefix = 'ERROR';
                break;
            case 'warn':
                prefix = 'WARN';
                break;
            case 'info':
            default:
                prefix = 'INFO';
        }
        ;
        return "".concat(prefix, ": ").concat(message, " ");
    };
    /**
     * @desc get debug statement style
     */
    Logger.prototype._getDebugStyle = function (type) {
        switch (type) {
            case 'error':
                return 'background: #ffcccc';
            case 'warn':
                return 'background: #ffffcc';
            case 'info':
            default:
                return '';
        }
    };
    /**
     * @desc get console handler
     */
    Logger.prototype._getConsoleHandler = function (type) {
        switch (type) {
            case 'error':
                return console.error;
            case 'warn':
                return console.warn;
            case 'info':
            default:
                return console.log;
        }
    };
    /**
     * @desc log info interface (log of info type)
     */
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        void args;
    };
    /**
     * @desc log warn interface (log of warning type)
     */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        void args;
    };
    /**
     * @desc log error interface (log of error type)
     */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        void args;
    };
    return Logger;
}());
/**
  * @desc get debug mode set in localstorage
  */
var getStorageDebugMode = function () {
    var debugMode = window.localStorage.getItem('BSS_SIM_DEBUG');
    return validateDebugMode(debugMode);
};
/**
  * @desc validate BSS debug mode. Should be one of these: 'log', 'warn', 'error', 'all'
  */
var validateDebugMode = function (debugMode) {
    if (debugMode) {
        var filteredDebugMode = debugMode.split(',')
            .map(function (mode) { return trim(mode); })
            .filter(function (mode) {
            return isDebugModeValidValue(mode);
        });
        if (filteredDebugMode.length) {
            // only unique values
            return uniq(filteredDebugMode);
            ;
        }
        return null;
    }
    return null;
};
/**
  * @desc check if debug mode has correct values
  */
var isDebugModeValidValue = function (debugMode) {
    return includes(['info', 'warn', 'error', 'all'], trim(debugMode));
};
var logger = new Logger(getStorageDebugMode());
// export Logger singleton instance 
export default logger;
